import type { SVGProps } from 'react';

/**
 * Выбранный игровой знак: округлый контур, крестовина и четыре кнопки ромбом.
 * Геометрия оптически рассчитана для 16px; цвет приходит от контекста.
 */
export const GamepadIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinejoin="round"
      d="M1.25 10.75C1.55 7.25 1.7 3.25 5 3.25 6.3 3.25 6.8 4 8 4s1.7-.75 3-.75c3.3 0 3.45 4 3.75 7.5.2 1.5-.55 2.25-1.5 2.25-1.45 0-1.6-2.35-3.25-2.35H6C4.35 10.65 4.2 13 2.75 13c-.95 0-1.7-.75-1.5-2.25Z"
    />
    <path fill="currentColor" d="M4 5h1v1.5h1.5v1H5V9H4V7.5H2.5v-1H4V5Z" />
    <g fill="currentColor">
      <circle cx="11" cy="5.75" r="0.65" />
      <circle cx="9.5" cy="7.25" r="0.65" />
      <circle cx="12.5" cy="7.25" r="0.65" />
      <circle cx="11" cy="8.75" r="0.65" />
    </g>
  </svg>
);
